import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import BookingmoduleIcon from 'src/assets/images/icon_company_bookingmodul.svg'
import InformationIcon from 'src/assets/images/icon_company_oplysninger.svg'
import UsersIcon from 'src/assets/images/icon_company_medarbjedere.svg'
import AttributesIcon from 'src/assets/images/icon_company_attributes.svg'
import FavoriteAddressIcon from 'src/assets/images/icon_company_favorite_address.svg'
import VouchersIcon from 'src/assets/images/icon_company_taxibon.svg'
import AccountIcon from 'src/assets/images/icon_company_konto.svg'
import FixedTripIcon from 'src/assets/images/icon_company_faste_ture.svg'
import DiscountCodeIcon from 'src/assets/images/icon_company_discount_codes.svg'
import Header from 'src/components//header/Header'
import styles from './settings.module.scss'
import { IBranch, IState } from 'src/Interface'
import { StateContext, DispatchContext } from '../../AppContext'
import DropDown from 'src/components/dropDown/Dropdown'
import Button from 'src/components/button/Button'
import axios from 'axios'
import { baseApiURL } from 'src/utils/utils'
import SubHeader from 'src/components/subHeader/SubHeader'
import useCancellablePromise from 'src/utils/useCancellablePromise'

const Settings: React.FunctionComponent = () => {
  const history = useHistory()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const state: IState = useContext(StateContext)
  const dispatch: React.Dispatch<any> = useContext(DispatchContext)
  const { cancellablePromise } = useCancellablePromise()

  useEffect(() => {
    if (state.user.accessToken && state.user.companyId) {
      if (state.user.role === 'BranchAdmin') {
        cancellablePromise(axios(`${baseApiURL()}/companies/${state.user.companyId}/branches/${state.user.branchId}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result: any) => {
          dispatch({ type: 'SET_COMPANY', company: result.data })
          setLoading(false)
        }))
      } else {
        cancellablePromise(axios(`${baseApiURL()}/companies/${state.user.companyId}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result: any) => {
          dispatch({ type: 'SET_COMPANY', company: result.data })
          setLoading(false)
        }))
      }
    }
  }, [dispatch, state.user.accessToken, state.user.branchId, state.user.companyId, state.user.role, cancellablePromise])

  const handleLocationChange = (locationName: string) => {
    const location = state.company.branches.find(branch => branch.name === locationName)
    if (location) {
      history.push({
        pathname: `/companies/${state.user.companyId}/branch/${location.id}`,
        state: { companyName: state.company.name }
      })
    }
  }

  const locations = useMemo(() => {
    if (state.company.branches) {
      return state.company.branches.map((branch: IBranch) => ({ label: branch.name, value: branch.name }))
    }
    return []
  }, [state.company.branches])





  return (
    <>
      <Header />
      <SubHeader loading={loading} title='Indstillinger'>
        {state.company.branches && state.company.branches.length > 1 && state.user.role !== 'BranchAdmin' && <DropDown readOnly={state.company.status === 'INACTIVE'} handleOnChange={(location: string) => handleLocationChange(location)} options={locations} placeholder='Vælg lokation' />}
        {state.user.role !== 'BranchAdmin' && <Button modifiers='tw-ml-5' type='secondary' label='Ny lokation'
          iconLeft={
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          }
          handleClick={() => dispatch({ showModal: true, type: 'SHOW_MODAL', modalType: 'addBranch', companyId: state.user.companyId })} />}
      </SubHeader>
      <main className={`${styles.container} ${loading ? 'animate-pulse' : ''}`}>
        <div className={styles.containerHeader}>
          <div className="tw-container tw-mx-auto tw-flex-wrap tw-flex tw-flex-col">
            <div className={styles.logoContainer}>
              {loading ? <div className={styles.logoLoading} /> :
                <>
                  {state.company.avatarImageUrl ?
                    <div className={styles.logo}>
                      <img className='tw-w-full' src={state.company.avatarImageUrl} alt="" />
                    </div>
                    : <div className={styles.logo} style={{ background: state.company.hexColor }}>{state.company.name.charAt(0)}</div>}
                  <h2 className='tw-ml-5'>{state.company.name}</h2>
                </>}
            </div>
            <div className='tw-flex'>
              {loading ?
                <>
                  <div className='label-loading label-loading--large tw-mr-20' />
                  <div className='label-loading tw-mr-20' />
                  <div className='label-loading tw-mr-20' />
                  <div className='label-loading label-loading--small tw-mr-16' />
                </>
                : <>
                  {state.company.address && <p className={styles.text}>
                    <span className={styles.label}>Adresse</span>
                    {state.company.address.fullAddress}
                  </p>}
                  {state.company.contactPerson && <p className={styles.text}>
                    <span className={styles.label}>Kontaktperson</span>
                    {state.company.contactPerson}
                  </p>}
                  {state.company.email && <p className={styles.text}>
                    <span className={styles.label}>Kontakt e-mail</span>
                    {state.company.email}
                  </p>}
                  {state.company.ordersCount > 0 && <p className={styles.text}>
                    <span className={styles.label}>Ture kørt</span>
                    {state.company.ordersCount}
                  </p>}
                </>}
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <div className="tw-container tw-mx-auto tw-flex-wrap tw-items-center tw-flex">
            {state.user.role !== 'BranchAdmin' && <div className={loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} onClick={() => dispatch({ type: 'SHOW_ASIDE', asideType: 'CompanyDetails', show: true, size: 'small', companyId: state.user.companyId })}>
              {!loading && <img src={InformationIcon} alt="" />}
              <h3 className={styles.boxTitle}>Oplysninger</h3>
              <p>Indstil virksomhedens profil.</p>
            </div>}
            {(state.user.role === 'DanTaxiAdmin' || state.user.role === 'CompanyAdmin') &&
              <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/companies/${state.company.id}/accounts`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={AccountIcon} alt="" />}
                <h3 className={styles.boxTitle}>Konto</h3>
                <p>Indstil virksomhedens konti.</p>
              </div>}
            {(state.company.branchesCount === 1 || state.user.role === 'BranchAdmin') &&
              <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/companies/${state.user.companyId}/${state.user.branchId}/users`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={UsersIcon} alt="" />}
                <h3 className={styles.boxTitle}>Medarbejdere</h3>
                <p>Opdater basis informationerne.</p>
              </div>}
            {(state.user.role === 'DanTaxiAdmin' || state.user.role === 'CompanyAdmin') && state.company.branchesCount === 1 &&
              <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/companies/${state.user.companyId}/${state.user.branchId}/fixed-trips`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={FixedTripIcon} alt="" />}
                <h3 className={styles.boxTitle}>Faste ture</h3>
                <p>Indstil faste ture til bestilling.</p>
              </div>}
            {(state.user.role === 'DanTaxiAdmin' || state.user.role === 'CompanyAdmin') &&
              <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/companies/${state.user.companyId}/booking-module`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={BookingmoduleIcon} alt="" />}
                <h3 className={styles.boxTitle}>Bookingmodule</h3>
                <p>Indstil booking siden.</p>
              </div>}
            {state.user.role === 'DanTaxiAdmin' &&
              <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/attributes`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={AttributesIcon} alt="" />}
                <h3 className={styles.boxTitle}>Attributes</h3>
                <p>Indstil attributter til bookingmodulet.</p>
              </div>}
            {(state.user.role === 'DanTaxiAdmin' || state.user.role === 'CompanyAdmin') &&
              state.company.branchesCount === 1 && <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/companies/${state.user.companyId}/${state.user.branchId}/addresses`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={FavoriteAddressIcon} alt="" />}
                <h3 className={styles.boxTitle}>Favoritadresser</h3>
                <p>Tilføj og administrer favoritadresser</p>
              </div>}
            {window.showV2Features && state.user.role === 'DanTaxiAdmin' &&
              <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
                pathname: `/discount-code`,
                state: { from: 'Indstillinger', backPath: location.pathname }
              }) : null}>
                {!loading && <img src={DiscountCodeIcon} alt="" />}
                <h3 className={styles.boxTitle}>Rabatkoder</h3>
                <p>Opret og håndtér rabatkoder</p>
              </div>}
            {window.showV2Features && (state.user.role === 'DanTaxiAdmin' || state.user.role === 'CompanyAdmin') && state.company.branchesCount === 1 && <div className={`${loading ? 'box-loading box-loading--large tw-mr-4' : styles.boxes} ${state.company.status === 'INACTIVE' ? styles.boxDisabled : ''}`} onClick={state.company.status === 'ACTIVE' ? () => history.push({
              pathname: `/companies/${state.company.id}/${state.company.branches[0].id}/vouchers`,
              state: { background: location }
            }) : null}>
              {!loading && <img src={VouchersIcon} alt="" />}
              <h3 className={styles.boxTitle}>Taxibon</h3>
              <p>Indstil taxibon detaljer</p>
            </div>}
          </div>
        </div>
      </main>
    </>
  )
}

export default Settings
